import { Alert, Box, Icon, Text } from '@factorialco/deprecated-design-system'

import styles from './index.module.scss'

export const Title = ({ children }: React.PropsWithChildren<Record<string, unknown>>) => (
  <Text.Header2>{children}</Text.Header2>
)
export const Description = ({ children }: React.PropsWithChildren<Record<string, unknown>>) => (
  <Text size="300" weight="normal">
    {children}
  </Text>
)

export const Note = ({ children }: React.PropsWithChildren<Record<string, unknown>>) => {
  return (
    <Box
      width="full"
      paddingX="s32"
      paddingY="s16"
      background="grey200"
      borderRadius={{ all: 'abs008' }}
    >
      <Text size="300" weight="normal">
        {children}
      </Text>
    </Box>
  )
}

export const ListEl = ({ children }: React.PropsWithChildren<Record<string, unknown>>) => (
  <li>{children}</li>
)

export const List = ({ children }: React.PropsWithChildren<Record<string, unknown>>) => {
  return <ol className={styles.list}>{children}</ol>
}

export const DottedList = ({ children }: React.PropsWithChildren<Record<string, unknown>>) => {
  return <ul className={`${styles.list} ${styles.dotted}`}>{children}</ul>
}

export const AlertMessage = ({ children }: React.PropsWithChildren<Record<string, unknown>>) => {
  return (
    <Alert>
      <Box alignItems="flexStart" flexDirection="row" gap="s4">
        <Box flexNoShrink>
          <Icon.Medium icon="alert-circle" color="grey800" />
        </Box>
        <Text.Normal>{children}</Text.Normal>
      </Box>
    </Alert>
  )
}
